import { render, staticRenderFns } from "./maintain-project-items.vue?vue&type=template&id=e5415344&scoped=true"
import script from "./maintain-project-items.vue?vue&type=script&lang=ts"
export * from "./maintain-project-items.vue?vue&type=script&lang=ts"
import style0 from "./maintain-project-items.vue?vue&type=style&index=0&id=e5415344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5415344",
  null
  
)

export default component.exports